<template>
  <div id="HomePage">
    <!-- 视频 -->
    <div id="swiper1">
      <div class="banner-swiper1">
        <div class="con">
        <video
          class="video-bg"
          id="vid"
          preload=""
          loop=""
          muted=""
          playsinline=""
          autoplay="autoplay"
        >
          <source src="https://cunbao-dev.oos-sdqd.ctyunapi.cn/resource/banner.mp4" type="video/mp4" />
        </video>
        <div class="text">梦想无高低，且触手可及</div>
      </div>
      </div>
    </div>
    <!-- 企业文化 -->
    <div class="test">
      <div class="a" @click="checkDetail(1)">
        <img src="@/assets/img/home_1.png" />
        <h1>企业文化与原则</h1>
        <p>在共同创业的同时为家乡谋福利</p>
      </div>
    <!-- 政策 -->
      <div class="b" @click="checkDetail(2)">
        <img src="@/assets/img/home_2.png" />
        <h1>破土而出 厚植乡村</h1>
        <p>政策护航，有效借力</p>
      </div>
    </div>
    <!-- 四个特点 -->
    <div class="vodeo">
      <div class="v">
        <!-- <img src="@/assets/img/vodio.png" alt="" /> -->
        <video
          class="video-bg"
          id="vid"
          preload=""
          loop=""
          muted=""
          playsinline=""
          autoplay="autoplay"
        >
          <source src="https://cunbao-dev.oos-sdqd.ctyunapi.cn/resource/202205101052.mp4" type="video/mp4" />
        </video>
        <!-- <h1>文案占位</h1>  -->
        <div class="play-view">
          <div class="play-content-view">
            <div class="play-hint-title">{{videoTitle}}</div>
            <div class="play-hint-msg">{{videoMsg}}</div>
          </div>
        </div>
        <!-- <div class="play-text" @click="playVideo(true)">观看影片<span class="icon-play"></span></div> -->
      </div>
    </div>
    <!-- <div 
      v-bind:class="['video-contain-village video-contain', hiddenVideo ? 'remove-video' : '']">
      <div class="close-btn" @click="playVideo(false)"></div>

      <video ref="video" class="video-js vjs-big-play-centered" id="video-village" controls poster="MY_VIDEO_POSTER.jpg" style="width:100%; height: 100%;" data-setup="{}">
        <source src="https://cunbao-dev.oos-sdqd.ctyunapi.cn/resource/202205101052.mp4" type="video/mp4">
        <p class="vjs-no-js">
          为了能浏览视频，换个支持播放视频的
          <a href="//videojs.com/html5-video-support/" target="_blank">浏览器</a>
          吧
        </p>
      </video>
    </div> -->
    <!-- <div class="testtwo">
      <div class="c">
        <a href=""><img src="@/assets/img/home_1_1.png" /></a>
        <div class="text1">
            <h1>使命</h1>
        </div> 
      </div>
    </div>   -->

  


   
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import Video from "video.js";

export default {
  name: "HomePage",
  data() {
    return {
      hiddenVideo: true,
      videoIndex: 0,
      videoTitlelist: [
        {
          title: "我们的使命",
          content: "山童是一群从农村走进城市的人共同组成的初创公司，我们秉着海纳百川的态度号召各地有乡村情怀年轻人一道加入到乡村振兴的事业中来，在共同创业的同时为家乡谋福利"
        },
        {
          title: "梦想无高低",
          content: "这是一个每个想创造财富的人都能实现梦想的平台。无论职业、年龄、教育背景、身处城市还是农村、只要愿意尝试的追梦者都可以加入“合作社”来创造自己的价值"
        },
        {
          title: "风险更小，体量更大",
          content: "乡村振兴正处于政策的风口，是一个长期战，传统的创业模式的高成本限制了很多创业者的尝试。我们：人多，投入较少，人人都是创业者，集大家的智慧，做最优的投资。"
        },
        {
          title: "云端创业",
          content: "无需亲力亲为，手机+移动网络实现云端创业。"
        }
      ]
    };
  },
  created() {
    this.updateVideoInfo();
  },
  computed: {
    videoTitle() {
      if (this.videoIndex <this.videoTitlelist.length) {
        return this.videoTitlelist[this.videoIndex].title;    
      }
      return "";
    },
    videoMsg() {
      if (this.videoIndex <this.videoTitlelist.length) {
        return this.videoTitlelist[this.videoIndex].content;
      }
      return "";
    },
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: "fade",
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // 轮播图如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true,
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  // 跳转子页面
  methods: {
    checkDetail(type) {
      if (type == 1) {
        this.$router.push({path: 'homeDetail'})
      }else {
        this.$router.push({path: 'homeTwo'})
      } 
    },
    playVideo(value) {
      this.hiddenVideo = !value; 
      if (!value) { 
        this.$video(this.$refs.video).pause();
      }else {
        this.$video(this.$refs.video).play();
      }
    },
    updateVideoInfo() {
      setInterval(() => {
        this.videoIndex += 1;
        if (this.videoIndex > this.videoTitlelist.length - 1) {
          this.videoIndex = 0
        }
      }, 4000)
    }
  },
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
  height: 100%;
}
/* 主图 */
#swiper {
  height: 100%;
  width: 100%;
}
/* banner视频 */
.video-bg {
  transition: 0.35s;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
  height: 700px;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
  /* 主页banner图文字 */
.con{
 position: relative;
 display: flex;
 justify-content: center;
 align-items: center;
}
.con .text{
  font-size: 60px;
  position: absolute;
  color:#e4e4e4;
  font-weight: bold;
  letter-spacing:4px;
}
/* 企业文化 */
.test {
  justify-content: center;
  display: flex;
  position: relative;
}
.a {
  width: auto;
  height: auto;
  float: left;
  margin-top: 50px;
  padding: 0 20px 0 0;
}
/* left: 50px;
  top: 500px; */
.a h1 {
  position: absolute;
  /* left: 200px;
  top: 500px; */
  bottom: 60px;
  margin-left: 50px;
  color: white;
  font-weight: bold;
  text-align: left;
}
.a p {
  position: absolute;
  /* left: 200px;
  top: 570px; */
  bottom: 20px;
  margin-left: 50px;
  color: white;
  text-align: left;
  height: 32px;
  width: 400px;
  line-height: 32px;
  font-size: 20px;
}
.b {
  width: auto;
  height: auto;
  float: left;
  margin-top: 50px;
  padding: 0 0 0 20px;
}
/*  left: 830px; 
  top: 1120px; */
.b h1 {
  position: absolute;
  bottom: 60px;
  margin-left: 50px;
  color: white;
  font-weight: bold;
  text-align: left;
}
.b p {
  position: absolute;
  bottom: 20px;
  margin-left: 50px;
  color: white;
  text-align: left;
  height: 32px;
  width: 400px;
  line-height: 32px;
  font-size: 20px;
}
.a img {
  /* cursor: pointer; */
  transition: all 0.6s;
}
/* .a:hover img{
    box-shadow: 0 0 15px #00000033;
} */
.a:hover img {
  transform: scale(1.02);
}
.b img {
  /* cursor: pointer; */
  transition: all 0.6s;
}
/* .b:hover img{
    box-shadow: 0 0 15px #00000033;
} */
.b:hover img {
  transform: scale(1.02);
}
/* 四个特点 */
.testtwo {
  justify-content: center;
  display: flex;
}
.c {
  width: auto;
  height: auto;
  float: left;
  margin-top: 50px;
  padding: 0 16px;
  position: relative;
}
.text1 h1 {
  position: absolute;
  left: 40px;
  top: 50px;
  color: #333;
  font-size: 30px;
  font-weight: bold;
  text-align: left;
}
.c img {
  /* cursor: pointer; */
  transition: all 0.6s;
  width: 1216px;
  height: 480px;
}
/* .c:hover img{
    box-shadow: 0 0 15px #00000033;
} */
.c:hover img {
  transform: scale(1.02);
}
/* 播放视频 */
.vodeo {
  display: flex;
  justify-content: center;
  margin-top: 100px;
  padding: 0 0 50px 0;
}
.v{
  position: relative;
  background: #000000;
  width: 1216px;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.v .play-view {
  position: absolute;
  left: 0;
  width: 100%;
  /* top: 0;
  height: 100%;
  background: rgba(0,0,0,0.5);
  color: #fff; */
}
.v .play-view .play-content-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.play-hint-title {
  font-size: 50px;
  font-weight: bold;
  color: white;
}
.play-hint-msg {
  font-size: 16px;
  font-weight: 500;
  color: white;
  margin-top: 25px;
  width: 70%;
  text-align: center;
  letter-spacing: 1px;
  line-height: 32px;
}
.v .play-text {
  position: absolute;
  right: 20px;
  bottom: 30px;
  font-size: 20px;
  line-height: 22px;
  color: white;
  display: flex;
  text-align: center;
  cursor: pointer;
}
.v .play-text .icon-play {
  display: inline-block;
  background: url(../assets/img/dingwei_icon.png) no-repeat center;
  background-size: cover;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-left: 5px;
}
.v h1{
    font-size: 32px;
    text-align: center;
    margin-bottom: 15px;
}
.v p{
    font-size: 18px;
    color: white;
    text-align: center;
    position: absolute;
}
.vodeo img {
  width: 1216px;
  height: 480px;
  opacity: 0.6;
  filter: alpha(opacity= 80);
}
.content {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding: 0 0 100px 0;
}
.conatiner-fuild {
  padding: 100px 0 0 0;
}

/* banner图 */
#swiper1 .banner-swiper1 {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat center;
  padding-right: 0%;
  padding-left: 0%;
  background: #000000;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper1 {
    height: auto;
    width: auto;
  }
  /* banner图 */
#swiper1 .banner-swiper1 {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat center;
  padding-right: 0%;
  padding-left: 0%;
  background: #000000;
}
  /* 主页banner图文字 */
  .con{
 position: relative;
 display: flex;
 justify-content: center;
 align-items: center;
}
.con .text{
  font-size: 26px;
  position: absolute;
  color:#e4e4e4;
  font-weight: bold;
  letter-spacing:6px;
}
/* 企业文化 */
.test {
  /* justify-content: center; */
  display: block;
  position: relative;
  width: auto;
  height: auto;
}
.a {
  width: 100%;
  height: auto;
  float: left;
  margin-top: 50px;
  padding: 0 0px 0 0;
  position:relative;
  text-align:center; 
}
.a img{
  width: 100%;
}
/* left: 50px;
  top: 500px; */
.a h1 {
  position: absolute;
  bottom: 60px;
  margin-left: 50px;
  color: white;
  font-weight: bold;
  text-align: left;
}
.a p {
  position: absolute;
  bottom: 20px;
  margin-left: 50px;
  color: white;
  text-align: left;
  height: 32px;
  width: 300px;
  line-height: 32px;
  font-size: 20px;
}
.b {
  width: 100%;
  height: auto;
  float: left;
  margin-top: 50px;
  padding: 0 0px 0 0;
  position:relative;
  text-align:center; 
}
.b img{
  width: 100%;
}
/*  left: 830px; 
  top: 1120px; */
.b h1 {
  position: absolute;
  bottom: 60px;
  margin-left: 50px;
  color: white;
  font-weight: bold;
  text-align: left;
}
.b p {
  position: absolute;
  bottom: 20px;
  margin-left: 50px;
  color: white;
  text-align: left;
  height: 32px;
  width: 300px;
  line-height: 32px;
  font-size: 20px;
}
.a img {
  /* cursor: pointer; */
  transition: all 0.6s;
}
/* .a:hover img{
    box-shadow: 0 0 15px #00000033;
} */
.a:hover img {
  transform: scale(1.02);
}
.b img {
  /* cursor: pointer; */
  transition: all 0.6s;
}
/* .b:hover img{
    box-shadow: 0 0 15px #00000033;
} */
.b:hover img {
  transform: scale(1.02);
}
/* 中间视频 */
/* 播放视频 */
.vodeo {
  display: flex;
  justify-content: center;
  margin-top: 100px;
  padding: 100px 0 50px 0;
  min-width: 300px;
}
.v{
  position: relative;
  background: #000000;
  width: 1216px;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.v .play-view {
  position: absolute;
  left: 0;
  width: 100%;
  /* top: 0;
  height: 100%;
  background: rgba(0,0,0,0.5);
  color: #fff; */
}
.v .play-view .play-content-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.play-hint-title {
  font-size: 40px;
  font-weight: bold;
  color: white;
}
.play-hint-msg {
  font-size: 16px;
  font-weight: 500;
  color: white;
  margin-top: 25px;
  width: 70%;
  text-align: center;
  letter-spacing: 1px;
  line-height: 32px;
}
.v .play-text {
  position: absolute;
  right: 20px;
  bottom: 30px;
  font-size: 20px;
  line-height: 22px;
  color: white;
  display: flex;
  text-align: center;
  cursor: pointer;
}
.v .play-text .icon-play {
  display: inline-block;
  background: url(../assets/img/dingwei_icon.png) no-repeat center;
  background-size: cover;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-left: 5px;
}
.v h1{
    font-size: 32px;
    text-align: center;
    margin-bottom: 15px;
}
.v p{
    font-size: 18px;
    color: white;
    text-align: center;
    position: absolute;
}
.vodeo img {
  width: 1216px;
  height: 480px;
  opacity: 0.6;
  filter: alpha(opacity= 80);
}
.content {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding: 0 0 100px 0;
}
.conatiner-fuild {
  padding: 100px 0 0 0;
}
  
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    height: 100px;
    width: 100px;
    padding: 20px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 100px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}

.video-contain, .video-contain-village {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 1;
    transition:.35s
}

.video-contain.remove-video, .video-contain-village.remove-video {
    display:none
}

.video-contain.hide-video, .video-contain-village.hide-video {
    opacity:0
}

.video-contain > .close-btn, .video-contain-village > .close-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    top: 20px;
    right: 20px;
    position: absolute;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.15);
    cursor:pointer
}

.video-contain > .close-btn:hover::before, .video-contain > .close-btn:hover::after, .video-contain-village > .close-btn:hover::before, .video-contain-village > .close-btn:hover::after {
    background-color: #d3d3d3;
    cursor:pointer
}

.video-contain > .close-btn::before, .video-contain > .close-btn::after, .video-contain-village > .close-btn::before, .video-contain-village > .close-btn::after {
    position: absolute;
    left: 18px;
    content: ' ';
    height: 25px;
    top: 7px;
    width: 2px;
    transition: .35s;
    background-color:#666
}

.video-contain > .close-btn::before, .video-contain-village > .close-btn::before {
    -ms-transform: rotate(45deg);
    transform:rotate(45deg)
}

.video-contain > .close-btn::after, .video-contain-village > .close-btn::after {
    -ms-transform: rotate(-45deg);
    transform:rotate(-45deg)
}


</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue